import React from 'react'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { connect } from 'react-redux'
import { DumbField } from 'components/Wizard2/Field'
import { TextInput } from 'components/Wizard2/fieldComponents/Form'
import { FrequentPayorUserEditorSection } from '../FrequentPayor/FrequentPayor'
import { UPDATE_WEB_USER } from 'requests'
import { spreadAuthAttributes } from '../../Auth/AuthActions'
import './UserAccountEditor.scss'
import { MASK } from '../Wizard2/validate'
import { GET_APP_SETTING_BY_NAME } from '../../requests'
import { Spinner } from 'components/Loaders/Loaders'
import toggleModalObscuredContext from './toggleModalObscuredContext'
import AddressBlock from '../Wizard2/fieldComponents/AddressBlock'
import { getAddressObject } from 'components/Wizard2/WizardClasses'

class UserAccountEditor extends React.Component {
  state = {
    error: null,
    obscured: false,
  }
  componentWillReceiveProps = (nextProps) => {
    if (this.props.isOpen === false && nextProps.isOpen === true) {
      this.setState({ error: null })
    }
  }  

  saveUser = (closeModal) => {
    this.setState({ error: null })
    const values = this.getEditorState()
    UPDATE_WEB_USER(
      {
        firstName: values.FIRST_NAME,
        middleName: values.MIDDLE_NAME,
        lastName: values.LAST_NAME,
        orgName: values.ORG_NAME,
        email: process.env.SEPARATE_USERNAME_AND_EMAIL ? values.EMAIL : values.USERNAME,
        username: process.env.SEPARATE_USERNAME_AND_EMAIL ? values.USERNAME : '',
        phone: values.PHONE,
        addr1: values.ADDRESS ? values.ADDRESS.ADDR1 : '',
        addr2: values.ADDRESS ? values.ADDRESS.ADDR2 : '',
        addr3: values.ADDRESS ? values.ADDRESS.ADDR3 : '',
        city: values.ADDRESS ? values.ADDRESS.CITY : '',
        state: values.ADDRESS ? values.ADDRESS.STATE : '',
        postal_code: values.ADDRESS ? values.ADDRESS.POSTAL_CODE : '',
        country: values.ADDRESS ? values.ADDRESS.COUNTRY : '',
      },
      (success) => {
        if (success) {
          closeModal();
          localStorage.setItem('WEB_USER', JSON.stringify(values));
          const { FIRST_NAME, MIDDLE_NAME, LAST_NAME, ORG_NAME, USERNAME, EMAIL, ADDRESS, PHONE } = values
          this.props.spreadAuthAttributes({
            FIRST_NAME,
            LAST_NAME,
            MIDDLE_NAME,
            ORG_NAME,
            USERNAME,
            EMAIL,
            ...ADDRESS,
            PHONE,
          })
        }
      },
      (err) => {
        this.setState({ error: err.message || err.Message })
      }
    )
  }
  cancel = () => {}
  toggleModalObscured = (obscured) => {
    this.setState((state) => ({
      obscured: obscured !== undefined ? obscured : !state.obscured,
    }))
  }
  render() {
    const { isOpen, onClose } = this.props
    const showSaveAndClose = process.env.MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON
    return (
      <Portal isOpened={isOpen}>
        <toggleModalObscuredContext.Provider value={this.toggleModalObscured}>
          <Modal
            closeModal={onClose}
            modalSize="small"
            title={process.env.EDIT_ACCOUNT_LABEL || 'Edit My Account'}
            cancelButton
            cancelButtonText={showSaveAndClose ? 'Cancel' : 'Close'}
            saveButton={showSaveAndClose}
            save={this.saveUser}
            cancel={this.cancel}
            ref={(ref) => (this.modal = ref)}
            autoHeight
            rootClassName={this.state.obscured ? 'modal-obscured' : ''}
          >
            <EditorForm
              getStateCallback={(r) => (this.getEditorState = r)}
              error={this.state.error}
            />
          </Modal>
        </toggleModalObscuredContext.Provider>
      </Portal>
    )
  }
}
export default connect(null, { spreadAuthAttributes })(UserAccountEditor)

class EditorForm extends React.Component {
  state = {
    ...this.props.user,
    oktaDomainError: null,
    oktaDomainLoading: process.env.HAS_OKTA_LOGIN,
    oktaDomain: '',
    ADDRESS: process.env.SHOW_ADDRESS_ACCOUNT_CREATE ? 
      {
        ADDR1: this.props.user.ADDR1 || '',
        ADDR2: this.props.user.ADDR2 || '',
        ADDR3: this.props.user.ADDR3 || '',
        CITY: this.props.user.CITY || '',
        STATE: this.props.user.STATE || '',
        POSTAL_CODE: this.props.user.POSTAL_CODE || '',
        COUNTRY: this.props.user.COUNTRY || '',
      } 
      : 
      null
  }
  componentDidMount = () => {
    if (process.env.HAS_OKTA_LOGIN) {
      this.fetchOktaDomain()
    }
  }
  fetchOktaDomain = () => {
    GET_APP_SETTING_BY_NAME(
      'OKTA_DOMAIN',
      (setting) => {
        if (setting) {
          this.setState({
            oktaDomain: setting.VALUE,
            oktaDomainLoading: false,
          })
        }
      },
      (err) => {
        console.error(err)
        this.setState({ oktaDomainError: err, oktaDomainLoading: false })
      }
    )
  }
  getState = () => ({ ...this.state })
  componentWillReceiveProps = (nextProps) => {
    if (this.props.user.WEB_USER_ID !== nextProps.user.WEB_USER_ID) {
      this.setState({ ...nextProps.user })
    }
  }
  setValue = (value, key) => this.setState({ [key]: value })
  render() {
    const { error, getStateCallback } = this.props
    const fieldDisabled = process.env.HAS_OKTA_LOGIN
    getStateCallback(this.getState)

    return (
      <div className="user-account-editor wizard">
        {process.env.SEPARATE_USERNAME_AND_EMAIL ? 
          <React.Fragment>
            <DumbField label={`Username${process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE ? '*' : ''}`} fieldId="username">
            <TextInput
              width="100%"
              fieldId="username"
              onChange={(value) => this.setValue(value, 'USERNAME')}
              value={this.state.USERNAME}
              disabled={true}
            />
          </DumbField>
          <DumbField label={`Email${process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE ? '*' : ''}`} fieldId="email">
            <TextInput
              width="100%"
              fieldId="email"
              onChange={(value) => this.setValue(value, 'EMAIL')}
              value={this.state.EMAIL}
              disabled={fieldDisabled}
            />
          </DumbField>
          </React.Fragment>
        :
          <DumbField label={`Email${process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE ? '*' : ''}`} fieldId="email">
            <TextInput
              width="100%"
              fieldId="email"
              onChange={(value) => this.setValue(value, 'USERNAME')}
              value={this.state.USERNAME}
              disabled={fieldDisabled}
            />
          </DumbField>
        }
        <DumbField label="Phone" fieldId="phone">
          <TextInput
            width="100%"
            fieldId="phone"
            onChange={(value) => this.setValue(MASK.phone(value), 'PHONE')}
            value={this.state.PHONE}
            disabled={fieldDisabled}
            disableSelectionRestoration
          />
        </DumbField>
        {process.env.SHOW_ORG_NAME_ACCOUNT_CREATE ? (
          <DumbField label="Organization Name" fieldId="orgName">
            <TextInput
              width="100%"
              fieldId="orgName"
              onChange={(value) => this.setValue(value, 'ORG_NAME')}
              value={this.state.ORG_NAME}
              disabled={fieldDisabled}
            />
          </DumbField>
        ) : null}
        <div className="flex-row flex-3-column">
          <DumbField label={`First name${process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE ? '*' : ''}`} fieldId="firstname">
            <TextInput
              width="100%"
              fieldId="firstname"
              onChange={(value) => this.setValue(value, 'FIRST_NAME')}
              value={this.state.FIRST_NAME}
              disabled={fieldDisabled}
            />
          </DumbField>
          <DumbField label="Middle name" fieldId="middleName">
            <TextInput
              width="100%"
              fieldId="middleName"
              onChange={(value) => this.setValue(value, 'MIDDLE_NAME')}
              value={this.state.MIDDLE_NAME}
              disabled={fieldDisabled}
            />
          </DumbField>
          <DumbField label={`Last name${process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE ? '*' : ''}`} fieldId="lastname">
            <TextInput
              width="100%"
              fieldId="lastname"
              onChange={(value) => this.setValue(value, 'LAST_NAME')}
              value={this.state.LAST_NAME}
              disabled={fieldDisabled}
            />
          </DumbField>
        </div>
        {process.env.SHOW_ADDRESS_ACCOUNT_CREATE ? (
          <AddressBlock
            value={this.state.ADDRESS}
            onChange={value => {this.setValue(value, 'ADDRESS')}}
            width='100%'
            showCityStateZip
            allowSelection={false}
            singleColSize='col-12'
            showCountry={true}
            hideAttention={true}
            triColSizes={{
              CITY: 'col-4',
              STATE: 'col-4',
              POSTAL_CODE: 'col-4',
              ZIP: 'col-4'
            }}
          />
        ) :
          null
        }
        {process.env.HAS_OKTA_LOGIN && !this.state.oktaDomainError ? (
          <div className="flex-row" style={{ marginLeft: 8, marginTop: 11 }}>
            <a
              aria-disabled={this.state.oktaDomainLoading || true}
              href={`${this.state.oktaDomain}/enduser/settings`}
              className={`btn btn-primary btn-raised btn-nowrap ${
                this.state.oktaDomainLoading ? 'btn-disabled' : ''
              }`}
              style={{ pointerEvents: this.state.oktaDomainLoading ? 'none' : '' }}
            >
              Edit my account
              {this.state.oktaDomainLoading && (
                <div
                  className="flex-center"
                  style={{ marginLeft: 10, transform: 'scale(.7)', marginTop: -2 }}
                >
                  <Spinner themeColor="inherit" size="small" />
                </div>
              )}
            </a>
          </div>
        ) : null}
        {error && (
          <p className="danger-text">
            <em>{error}</em>
          </p>
        )}
        {this.state.isFrequentPayor ? <FrequentPayorUserEditorSection /> : null}
      </div>
    )
  }
}
EditorForm = connect((state) => ({
  user: state.auth,
  
}))(EditorForm)



// WEBPACK FOOTER //
// ./src/components/UserAccountEditor/UserAccountEditor.js